module.exports = __webpack_public_path__ + "static/media/jamrud.2b7b8bfa.png";